import { PlanSelection } from "@/components/setup/plan-selection";
import { SetupFormPaymentMethod } from "@/components/setup/setup-form-payment-method";
import { useStepper } from "@/components/ui/stepper";
import { useTeams } from "@/contexts/teams-provider";
import { useTranslation } from "@/hooks/useTranslation";

export const SetupTrialEndedBillingPaymentMethodPage = () => {
  const { nextStep } = useStepper();
  const { t } = useTranslation();
  const { teamSelected } = useTeams();

  const onCompleted = () => {
    nextStep();
  };

  return (
    <div className="space-y-7 w-full">
      <h1 className="text-2xl font-bold text-center text-primary">
        {t("setup.trialEndedBilling.paymentMethod.title")}
      </h1>

      <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
        <PlanSelection
          defaultSubscriptionType={teamSelected?.defaultBillingFrequency}
          defaultProLicenseCountMonthly={
            teamSelected?.initialProLicenseCountMonthly
          }
          defaultProLicenseCountAnnual={
            teamSelected?.initialProLicenseCountAnnual
          }
          hideTrialInfo={true}
          readOnly={true}
        />

        <div className="space-y-4">
          <p className="text-sm">
            {t("setup.trialEndedBilling.paymentMethod.payment.instruction")}
          </p>

          <SetupFormPaymentMethod onCompleted={onCompleted} />
        </div>
      </div>
    </div>
  );
};
